/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { Stage, DefaultNavigators, SceneCompass, ObjectInteractor } from '@sick-davinci/glow';

const containerEl = document.getElementById('viewer');
const stage = new Stage(containerEl, {
  cameras: [{
    name: 'cam',
    from: [0, 0, 4],
    to: [0, 0, 0],
    up: [0, 1, 0],
    fov: 45,
  }],
  scenes: [{ name: 'scene' }],
  viewports: [{
    name: 'view',
    scene: 'scene',
    camera: 'cam',
    navigator: 'orbit',
    bgcolor: 0x292929,
  }],
});

const interactor = new ObjectInteractor(stage, 'cam', 'view');
const sceneCompass = new SceneCompass({ interactor, sphereTextureSize: 512, controlCamera: stage.getCamera('cam')});

// activate front/back axes shading - normally this is automatically done while
// mirroring a camera orientation - but in this closeup demo there is no mirroring,
// so we need to manually trigger it ...
stage.addActor(sceneCompass.createShadeFrontBackAxesActor(stage.getCamera('cam')));

stage.applyThreeDirect((scene) => {
  scene.add(sceneCompass);
}, 'scene');

DefaultNavigators.initOrbit(stage, 'orbit', {
  straightAhead: { enable: false },
  pinchRoll: { enable: false },
  pan: { enable: false },
});

stage.start();
